import { ISimejiItem } from '@template/Simeji/simejiStatus.interface';
import React from 'react';
import styled from 'styled-components';

const HandSec = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  img,
  svg {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    user-select: none;
  }
`;
export interface Props {
  data: ISimejiItem;
  strokeWidth?: number;
  color?: string;
  eyelidColor?: string;
  skinColor?: string;
  lineColor?: string;
  stroke?: string;
  size?: string | number;
  onClick?: () => void;
}

function Hands({ data, skinColor, color, lineColor }: Props) {
  const { rightHandCloth, leftHandCloth } = data;

  // 옷도 포함할 것
  // 손의 모양은 항상 고정
  return (
    <HandSec className="hands body">
      <svg
        width="100"
        height="120"
        viewBox="0 0 100 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        color={data.lineColor}
      >
        {/* 왼쪽 */}
        <g className="left-hand">
          <path
            d="M41 86C41.6823 88.2085 40.6429 94.5 39.5 96.5C37.5 100 33.2177 105.491 28.8177 102.291C23.3177 98.2915 31.8177 92.2915 34.3177 89.7915C36.8177 87.2915 39.9563 82.622 41 86Z"
            fill={skinColor}
            stroke={lineColor}
          />
          {/* 왼팔 소매 기본 */}
          {!rightHandCloth && (
            <path
              d="M33 89.8303L40 97.3303C41.5 95.8303 44.4814 85.3847 42.5 84.3303C40 83 34.8333 87.3303 33 89.8303Z"
              fill={color}
              stroke={lineColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          )}
        </g>

        {/* 오른쪽 */}
        <g className="right-hand">
          <path
            d="M60.2175 86C59.5352 88.2085 60.5747 94.5 61.7175 96.5C63.7175 100 67.9999 105.491 72.3999 102.291C77.8999 98.2915 69.3999 92.2915 66.8999 89.7915C64.3999 87.2915 61.2612 82.622 60.2175 86Z"
            fill={skinColor}
            stroke={lineColor}
          />
          {/* 오른팔 소매 기본 */}
          {!rightHandCloth && (
            <path
              d="M68.1584 89.8303L61.1584 97.3303C59.6584 95.8303 56.677 85.3847 58.6584 84.3303C61.1584 83 66.3251 87.3303 68.1584 89.8303Z"
              fill={color}
              stroke={lineColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          )}
        </g>
      </svg>

      <img className="right-hand" src={rightHandCloth} alt="" />
      <img className="left-hand" src={leftHandCloth} alt="" />
    </HandSec>
  );
}

export default Hands;
